/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import { FC, memo } from 'react';
import { Comment, Icon, VersionValue } from './NewTypes';
import { ChatMessage } from './ChatMessage';

export interface ChatLineProps {
    vodId: string;
    line: Comment;
    onTimestampClicked: (timestamp: number) => void;
    badgeMap: Map<string, VersionValue>;
    emoteMap: Map<string, Icon>;
}

export const ChatLine: FC<ChatLineProps> = memo(({ vodId, line, onTimestampClicked, badgeMap, emoteMap }) => {
    switch (line.message.user_notice_params.msg_id) {
        case "viewermilestone":
        case "resub":
        case "submysterygift":
        case "subgift":
            return (
                <div key={line._id} className="chat-line system-message">
                    {line.message.user_notice_params.system_msg}
                </div>
            );
        case "announcement":
            return (
                <div key={line._id} className="chat-line system-message">
                    {line.message.user_notice_params.params['user-message']}
                </div>
            )
        default:
            return <ChatMessage key={line._id} vodId={vodId} line={line} onTimestampClicked={onTimestampClicked} badgeMap={badgeMap} emoteMap={emoteMap}/>
    }
});
